/**
 * Store pour les statistiques des tons des publications de l'utilisateur connecté
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';
/***/
import { useManagingUser } from '@compositions/ManagingUser';
export const useAuthTonePublicationStatisticsStore = defineStore('authTonePublicationStatistics', (() => {

    // Composition pour l'utilisateur que l'on gère
    const { getManagingUser } = useManagingUser({});

    // State des données de la liste des statistiques des tons
    const tonesStatisticsList = ref({});

    // Retourne les données des statistiques des tons
    const getTonesStatisticsList = computed(() => tonesStatisticsList.value);

    /**
     * Chargement des statistiques des tons de l'utilisateur connecté
     * @param Object params
     * @return Promise
     */
    const loadTonesStatistics = ((params) => {

        const userId = getManagingUser.value.id;

        const path = `/api/users/${ userId }/tasks/publications/statistics/tones`;
        return axios.get(path, {
            params: params
        }).then((response) => {
            if(response && response.data && response.data.success && response.data.data) {
                if(params.offset === 0) {
                    resetTonesStatisticsList();
                }

                updateTonesStatisticsList(response.data.data);

                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Modifie la liste des statistiques des tons dans le store
     * @param data Données des templates : total et items
     * @return void
     */
    const updateTonesStatisticsList = ((data) => {

        const currentData = tonesStatisticsList.value;

        if(currentData.total === undefined) {
            tonesStatisticsList.value = {
                total: data.total,
                items: data.items
            };

        } else {
            tonesStatisticsList.value.total = data.total;

            const currentItems = tonesStatisticsList.value.items;
            const newItems = data.items.filter((item) => ! currentItems.find((current) => current.id === item.id));
            tonesStatisticsList.value.items = [ ...currentItems, ...newItems ];
        }

    });

    /**
     * Réinitialisation de la liste des statistiques des tons
     * @return void
     */
    const resetTonesStatisticsList = (() => {
        tonesStatisticsList.value = {};
    });

    return {
        getTonesStatisticsList,
        loadTonesStatistics,
        resetTonesStatisticsList
    };
}));


